import React from "react";
import Fox from "../../src/FoxDark.PNG";
import { useParams, useLocation } from "react-router-dom";
import { fetchData, fetchCategoryData } from "../api";
import { useQuery } from "react-query";
import identifyLessonCategory from "../helpers/identifyLessonCategory";

import BlogPost from "../components/BlogPost/BlogPost";

function Lesson() {
  const { id } = useParams();
  const location = useLocation();

  const category = identifyLessonCategory(location);

  const { data } = useQuery(["lesson", category, id], () =>
    fetchCategoryData("lesson", category, id)
  );

  const [authorData, setAuthorData] = React.useState([]);

  const keyFacts = React.useMemo(() => {
    return {
      name: data?.keyword,
      description: data?.keyfact,
      logo: data?.logo || Fox,
    };
  }, [data]);

  React.useEffect(() => {
    if (data?.author) {
      fetchData("authors", data?.author)
        .then((response) => {
          setAuthorData(response);
        })
        .catch((error) => {});
    }
  }, [data?.author]);

  return (
    <BlogPost
      data={data}
      meta={keyFacts}
      author={authorData}
      showInfo={true}
      category="knowledge"
    />
  );
}

export default Lesson;
